import React, { Component } from "react";
import { Field, reduxForm, FormSection, formValueSelector, reset } from "redux-form";
import axios from "axios";
import { TabContent, TabPane, Nav, NavItem, NavLink, Card, CardBody, Button, CardTitle, CardText, Row, Col, Pagination } from 'reactstrap';
import classnames from 'classnames';
import { connect } from "react-redux";
import PageSpinner from "../PageSpinner";
import Banner from "../common/banner";
import renderInput from "../common/renderinput";
import appConfig from '../../config/config';
import { LoadAllTaxes, ShowAddTax, ShowAddTaxPayment,SetTax, LoadAllPayments, SetTaxPayment } from "../../actions/loading";
import PropertyReportTaxComment from "./PropertyReportTaxComment";
import PropertyTaxGrid from "./PropertyTaxGrid";
import PropertyTaxPaymentGrid from "./PropertyTaxPaymentGrid";
import PropertyReportTax from "./PropertyReportTax";
import PropertyReportTaxPayment from "./PropertyReportTaxPayment";
import {MTSGetData} from '../../API/mtsapi';

const colHeader = [
    { dataField: 'ID', text: 'Sr No' },
    { dataField: 'Grantee', text: 'Parcel' },
    { dataField: 'Grantor', text: 'Land' },
    { dataField: 'Prior', text: 'Building' },
    { dataField: 'DEEDDATE', text: 'Total' },
    { dataField: 'RECDATE', text: 'Assesment Address' },
    { dataField: 'VOLINST', text: 'Pay' },
];
var orderColumns = colHeader.map(function (d) { return { dataField: d.dataField, text: d.text, sort: true } });

const colPaymentHeader = [
    { dataField: 'ID', text: 'Sr No' },
    { dataField: 'Type', text: 'Type' },
    { dataField: 'Period', text: 'Period' },
    { dataField: 'Year', text: 'Year' },
    { dataField: 'Amount', text: 'Amount' },
    { dataField: 'Date', text: 'Date' },
    { dataField: 'Status', text: 'Status' },
];
var orderPayColumns = colPaymentHeader.map(function (d) { return { dataField: d.dataField, text: d.text, sort: true } });






class PropertyReportTaxMain extends Component {
    constructor(...args) {
        super(...args);
    }
    componentDidMount() {
        console.log(this.props.OrderId)
        var data =  MTSGetData(
            appConfig.apiGateway.PropertyReport,
            { OrderId: this.props.OrderId, ProductId : this.props.OrderProductId, 'Action':'GetTax' }
        )
        data.then((response)=> {
            console.log(response.length)
            if (response.length > 0 )  //Deeds found
            {
                this.props.LoadAllTaxes(response);
                this.props.SetTax(response[0]);

                var subdata =  MTSGetData(
                    appConfig.apiGateway.updatePropertyReport,
                    { OrderId: this.props.OrderId, 
                        TaxId : response[0].ID,
                        ProductId : this.props.OrderProductId, 'Action':'GetTaxPayment' }
                )
                subdata.then((response)=> {
                    console.log(response.length)
                    if (response.length > 0 )  
                    {
                        this.props.LoadAllPayments(response);
                        this.props.SetTaxPayment(response[0]);
                    }
                }, (err)=>{
                    console.log(err)
                })
            }
        }, (err)=>{
            console.log(err)
        })
    }
    submit = (values) => {
        axios.post(
            appConfig.apiGateway.updatePropertyReport,
            JSON.stringify({
                ...values, OrderId: this.props.OrderId,
                OrderProductId: this.props.OrderProductId,
                Action: "Tax",
                UserName: this.props.session.session.user.name
            }),
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.props.session.session.credentials.accessToken}`
                }
            }
        ).then((response) => {
            if (response.data.Count > 0) {
                var myObject = JSON.parse(response.data.body);
                this.props.dispatch(reset('propertyReportTaxMainForm'))
            }
        },
            (error) => {

            });

    }

    render() {
        return (
            <>
                <span>Tax List</span>
                <PropertyTaxGrid  OrderColumns={orderColumns}  />
                <hr/>
                <PropertyReportTax/>
                <PropertyReportTaxPayment/>

                <hr/>
                <span>Payments</span>
                <PropertyTaxPaymentGrid OrderColumns={orderPayColumns} />
                <Button color="primary" onClick={()=>this.props.ShowAddTax()}>Add Tax</Button>
                <Button color="secondary" onClick={()=>this.props.ShowAddTaxPayment()}>Add Payment</Button>

                <hr/>
                <PropertyReportTaxComment />
            </>
        );
    }
}
const validate = (formValues) => {
    const errors = {};

    return errors;
}
var propertyReportTaxMainForm = reduxForm({
    form: 'propertyReportTaxMainForm',
    validate
})(PropertyReportTaxMain);

propertyReportTaxMainForm = connect(
    state => ({
        session: state.session
    }),{LoadAllTaxes, SetTax, LoadAllPayments, SetTaxPayment,ShowAddTax,ShowAddTaxPayment}
)(propertyReportTaxMainForm);

export default propertyReportTaxMainForm;